import React, { useEffect, useRef } from 'react'
import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButton,
  IonIcon,
} from '@ionic/react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import goBackIcon from '../../assets/images/goback.svg'
import SlotsCasinoPopUp from '../../components/SlotsCasinoPopup'
import { connectCasinoProvider } from '../CasinoProvider/CasinoProvider.connect'

const GapCasinoIframe = ({
  liveCasino,
  slotsGames,
  elementsParams,
  actions,
  slotCasinoPopUp,
  ...props
}) => {
  const { casinoId, categoryId, providerId } = useParams()
  const history = useHistory()
  const refIframe = useRef(null)
  const width =
    elementsParams && elementsParams?.clientWidth
      ? elementsParams?.clientWidth
      : window.innerWidth

  const endCasino = () => {
    history.goBack()
  }

  const gapCasinoUrl = useSelector((state) => state.liveCasino.gapCasinoUrl)

  const getGapGameList = (data) => {
    actions.requestGapCasinoID(data)
  }

  useEffect(() => {
    const payload = {
      game_id: casinoId,
      provider_name: providerId,
      category: categoryId,
    }
    getGapGameList(payload)
  }, [casinoId, providerId, categoryId])

  return (
    <>
      {slotCasinoPopUp && <SlotsCasinoPopUp />}
      {width < 1024 ? (
        <IonPage
          className="CasinoGames casinoLive__slot"
          style={width >= 1024 ? { paddingTop: `135px` } : {}}
        >
          <IonHeader>
            <IonToolbar className="CasinoGames__toolbar">
              <div className="CasinoGames__toolbar__wrapper">
                <div className="ion-toolbar__left">
                  <IonButton
                    className="menu-btn"
                    mode="md"
                    fill="clear"
                    onClick={endCasino}
                  >
                    <IonIcon
                      className="menu-icon go-back-icon"
                      src={goBackIcon}
                    />
                  </IonButton>
                  <div className="CasinoGames__toolbar__title">
                    Go Back GAP Casino
                  </div>
                </div>
              </div>
            </IonToolbar>
          </IonHeader>
          <IonContent fullscreen>
            {gapCasinoUrl && (
              <iframe
                className="CasinoGames__content__video"
                ref={refIframe}
                allowFullScreen
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                scrolling="yes"
                title="casino live"
                src={gapCasinoUrl}
              ></iframe>
            )}
          </IonContent>
        </IonPage>
      ) : (
        <IonPage
          className="CasinoGames casinoLive__slot"
          style={{ overflow: 'hidden!important' }}
        >
          <div style={{ height: '135px' }}></div>
          <IonHeader>
            <IonToolbar className="CasinoGames__toolbar">
              <div className="CasinoGames__toolbar__wrapper">
                <div className="ion-toolbar__left">
                  <IonButton
                    className="menu-btn"
                    mode="md"
                    fill="clear"
                    onClick={endCasino}
                  >
                    {/* <IonIcon className="menu-icon2 go-back-icon2" /> */}
                    <IonIcon
                      className="menu-icon go-back-icon"
                      src={goBackIcon}
                    />
                  </IonButton>
                  <div className="CasinoGames__toolbar__title">
                    Go Back GAP Casino
                  </div>
                </div>
              </div>
            </IonToolbar>
          </IonHeader>
          <div>
            {gapCasinoUrl && (
              <iframe
                className="CasinoGames__content__video"
                ref={refIframe}
                allowFullScreen
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                // scrolling="yes"
                title="casino live"
                src={gapCasinoUrl}
              ></iframe>
            )}
          </div>
        </IonPage>
      )}
    </>
  )
}

export default connectCasinoProvider()(GapCasinoIframe)
